@if (thumbs$ | async; as thumbs) {
  @if (isMobile() | async) {
    @if (thumbs.length) {
      <cx-carousel
        class="thumbs"
        [items]="thumbs"
        [itemWidth]="319 / thumbs.length + 'px'"
        [template]="thumb"
        [hideIndicators]="true"
        [enableMouseActions]="false"
      ></cx-carousel>
    }
  } @else {
    @if (thumbs.length) {
      <cx-carousel
        class="thumbs"
        [items]="thumbs"
        [itemWidth]="slideSize"
        [hideIndicators]="true"
        [template]="thumb"
        [enableMouseActions]="false"
        [activeMainItem]="activeIndex | async"
        (updateMainImage)="openImage($event)"
      ></cx-carousel>
    }
  }
}

<ng-template #thumb let-item="item">
  <cx-media
    cxFocusableCarouselItem
    [container]="item.container"
    tabindex="0"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
    >
  </cx-media>
</ng-template>
